import SortFilterWrapper from './SortFilterWrapper';

export default SortFilterWrapper;
